module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-180x180.png";